export default class User{
    constructor(){
        this.id = null;
        this.name = '';
    }
}